import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy} from "@ngneat/until-destroy";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams, RowNode} from "ag-grid-community";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {MatLegacySlideToggleChange as MatSlideToggleChange} from '@angular/material/legacy-slide-toggle';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-layout-filter-cell-renderer',
  templateUrl: './layout-filter-cell-renderer.component.html',
  styleUrls: ['./layout-filter-cell-renderer.component.scss']
})
export class LayoutFilterCellRendererComponent implements ICellRendererAngularComp, OnInit, OnDestroy {

  formGroup: UntypedFormGroup;
  isAssigned: boolean;
  node: RowNode;
  colId: string;

  constructor(private readonly formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.isAssigned = params.value;
    this.node = params.node;
    this.colId = params.column.getColId();

    this.formGroup = this.formBuilder.group({
      isAssigned: [this.isAssigned]
    });
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  onToggleChanged(event: MatSlideToggleChange) {
    if (event.checked !== this.isAssigned) {
      this.isAssigned = event.checked;
      this.node.setDataValue(this.colId, this.isAssigned);
    }
  }
}
